import Vue from 'vue';

export default {
  // 信息回显
  getPurchaseInfo (params) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/echo', {params});
  },

  // 保存采购信息
  savePurchaseInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/purchase/save', payload);
  },
  // 修改采购信息
  updatePurchaseInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/purchase/update', payload);
  },

  // 保存资格要求信息
  saveEligibilityRequirementsInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/purchase/saveEligibilityRequirements', payload);
  },
  // 修改资格要求信息
  updateEligibilityRequirementsInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/purchase/updateEligibilityRequirements', payload);
  },

  // 保存附件信息
  saveAttachmentInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/purchase/uploadFile', payload);
  },
  // 修改附件信息
  updateAttachmentInfo (payload) {
    return Vue.axios.post('/api/v1.0/chanquan/purchase/updateUploadFile', payload);
  },

  // 保存承诺书信息
  submitProjectProcess (purchaseId) {
    return Vue.axios.get('/api/v1.0/chanquan/purchase/submitProjectProcess/' + purchaseId);
  },
  //  获取注册位置
  getUserBaseInfo () {
    return Vue.axios.get('/api/v1.0/chanquan/user/getUserBaseInfo');
  },
  // 编辑采购文件保存
  saveProjectPurchaseFileInfo(params) {
    return Vue.axios.post('/api/v1.0/chanquan/purchase/saveProjectPurchaseFileInfo', params);
  },
  // 编辑采购文件更新
  updateProjectPurchaseFileInfo(params) {
    return Vue.axios.post('/api/v1.0/chanquan/purchase/updateProjectPurchaseFileInfo', params);
  }
};
